import { toaster } from '@utils/common';

export const handleAddSuccess = ({ email }: { email: string }) => {
    toaster.success({
        title: 'Sales Inbox Created',
        msg: `${email} inbox was created successfully.`,
    });
};

export const handleAddError = (error: unknown, values: { country_codes: string[] }) => {
    if (typeof error === 'object' && error !== null && 'data' in error) {
        const { data } = error;
        if (typeof data === 'object' && data !== null) {
            if ('email' in data) {
                toaster.failure({
                    title: 'Action Failed',
                    msg: 'Sales inbox with this email already exists. Please use a different email.',
                });
                return;
            }
            if ('country_codes' in data) {
                toaster.failure({
                    title: 'Action Failed',
                    msg: `Some of these countries are already associated with another inbox: ${values.country_codes.join(
                        ', '
                    )}. Please select different countries.`,
                });
                return;
            }
        }
    }

    toaster.failure({
        title: 'Action Failed',
        msg: "We couldn't perform the requested action. Please try again later.",
    });
};

export const handleEditSuccess = ({ email }: { email: string }) => {
    toaster.success({
        title: 'Sales Inbox Updated',
        msg: `${email} inbox was updated successfully.`,
    });
};

export const handleNoInboxIdError = () => {
    toaster.failure({
        title: 'Action Failed',
        msg: 'No inbox selected for editing. Please select an inbox and try again.',
    });
};

export const handleEditError = (error: unknown, values: { country_codes: string[] }) => {
    if (typeof error === 'object' && error !== null && 'data' in error) {
        const { data } = error;
        if (typeof data === 'object' && data !== null) {
            if ('email' in data) {
                toaster.failure({
                    title: 'Action Failed',
                    msg: 'Sales inbox with this email already exists. Please use a different email.',
                });
                return;
            }
            if ('country_codes' in data) {
                toaster.failure({
                    title: 'Action Failed',
                    msg: `Some of these countries are already associated with another inbox: ${values.country_codes.join(
                        ', '
                    )}. Please select different countries.`,
                });
                return;
            }
        }
    }

    toaster.failure({
        title: 'Action Failed',
        msg: "We couldn't perform the requested action. Please try again later.",
    });
};

export const handleActivateSuccess = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inbox activated successfully.',
        });
    } else {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inboxes activated successfully.',
        });
    }
};

export const handleDeactivateSuccess = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inbox deactivated successfully.',
        });
    } else {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inboxes deactivated successfully.',
        });
    }
};

export const handleActivateError = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to activate inbox. Please try again.',
        });
    } else {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to activate inboxes. Please try again.',
        });
    }
};

export const handleDeactivateError = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to deactivate inbox. Please try again.',
        });
    } else {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to deactivate inboxes. Please try again.',
        });
    }
};

export const handleDeleteSuccess = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inbox deleted successfully.',
        });
    } else {
        toaster.success({
            title: 'Action Successful',
            msg: 'Inboxes deleted successfully.',
        });
    }
};

export const handleDeleteError = (inboxIds: number[]) => {
    if (inboxIds.length === 1) {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to delete inbox. Please try again.',
        });
    } else {
        toaster.failure({
            title: 'Action Failed',
            msg: 'Failed to delete inboxes. Please try again.',
        });
    }
};
